export default "__VITE_ASSET__BmkCAEwT__"